<template lang="pug">
  el-card(shadow="hover",v-if="processo.id").card-container
    .titulo-analise
      el-menu(default-active="1" mode="horizontal" @select="handleSelect")
          el-menu-item(index="1") {{ tituloMenuEmissao }}
          el-menu-item(index="2") Análise do Processo
      app-opcoes-header-analise(
        :idProcesso="processo.id"
        :tipoProcesso="processo.tipo.codigo"
        :numeroProcesso="processo.numeroProcesso"
        :protocolo="processo.numeroProtocolo"
        :btnPendencia= "true",
      )
    template(
      v-if="step === 1"
    )
      el-steps.mt-20(:active='tela', finish-status='success', align-center, v-if="exibirSteps")
        el-step(
          :title='isEstadoMA ? "Visualizar Boleto(s)" : "Visualizar DAEs"'
          icon="el-icon-view"
          :status='tela > 0 ? "success" : "process"'
          v-if="visualizarDae"
        )
        el-step(
          :title="modoReparcelamento ? 'Informar novo plano de pagamento' : 'Informar dados do documento'"
          :status='tela === 2 ? "success" : "process"'
          icon="el-icon-edit-outline"
        )
        el-step(
          :title="modoReparcelamento ? 'Confirmar reparcelamento' : 'Confirmar dados'"
          status="process"
          icon="el-icon-tickets"
        )
      div()
        div()
          el-row.mb-20(type="flex", :gutter="40")
            el-col(v-if="tela === 0 && !isEstadoMAOrRR")
              app-pagamento(
                v-if="processo.numeroProcesso"
                :numeroProcesso="processo.numeroProcesso"
              )
            el-col(v-if="tela === 0 && isEstadoMAOrRR")
              app-pagamento-ma(
                v-if="processo.numeroProcesso && isEstadoMAOrRR"
                :parcelas="processo.parcelas"
                :numeroProcesso="processo.numeroProcesso"
                :idProcesso="processo.id"
                :tipoProcesso="processo.tipo.codigo"
                @reemitirDae="reemitirBoleto"
                @editarDae="editarDae"
                @recarregar="recarregarDadosPagamento"
                @irReparcelamento="iniciarReparcelamento"
              )
      div(v-if="isEstadoMAOrRR")
        div(v-if="tela === 1")
          el-row.mb-20(v-if="modoReparcelamento && resumoParcelasAtuais.length", type="flex", :gutter="20")
            el-col(:span="24")
              el-alert(type="warning", :closable="false", show-icon)
                template(slot="title") Reparcelamento do saldo em aberto
                p Cancelam-se boletos e parcelas não quitadas listadas abaixo. Ajuste o valor principal e o plano (à vista ou parcelado) antes de confirmar.
              el-table.mt-15(:data="resumoParcelasAtuais", stripe, size="small", border)
                el-table-column(label="Parcela", prop="rotulo", min-width="110")
                el-table-column(label="Valor", min-width="120")
                  template(slot-scope="scope")
                    | {{ formatValor(scope.row.valor) }}
                el-table-column(label="Situação da parcela", prop="situacaoParcela", min-width="140")
                el-table-column(label="Paga", prop="pagaLabel", width="80")
          el-row.mb-40(type="flex", justify="center", spaceBetween="20")
            validation-provider(rules="required", v-slot="{ errors }", name="Tipo de Pagamento")
              el-radio-group.checkbox-group.input(v-model="formaPagamento", @change="setRadio", :class="{'erro' : errors.length}", :disabled="isEdicao")
                el-radio(label="A_VISTA") Pagamento à vista
                el-radio(v-if="!isRoraima", label="PARCELADO") Pagamento parcelado
              span.help.erro {{ errors[0] }}
          validation-observer(ref='validation' tag='form')
            form(@submit.prevent="onSubmit" v-if="dadosInteressado")
              el-row.mb-20(v-if="isParcelado && !isEdicao && !isRoraima", type="flex", :gutter="40")
                el-col()
                  validation-provider(rules="required", v-slot="{ errors }")
                    app-label(label="Quantidade de parcelas:", required)
                    el-select(
                      v-model="parcelaSelecionada"
                      placeholder="Selecione"
                      value-key="parcela"
                      :class="{'select select-erro' : errors.length}"
                    )
                      el-option(
                        v-for="parcela in parcelas",
                        :key="parcela",
                        :label="parcela",
                        :value="parcela"
                      )
                    span.help.erro {{ errors[0] }}
              el-row.mb-20(v-if="isParcelado && isEstadoMA", type="flex", :gutter="40")
                el-col(:span="8")
                  validation-provider(rules="required|min_value:0", v-slot="{ errors }")
                    app-label(label="Taxa de juros (% ao período):", required)
                    app-double-input.input(
                      v-model="taxaJurosPercentual"
                      suffix='%'
                      :step="0.01"
                      :precision="2"
                      :class="{'erro' : errors.length}"
                    )
                    span.help.erro {{ errors[0] }}
                el-col(:span="12", style="display:flex; align-items: flex-end")
                  el-checkbox(v-model="jurosPeriodicidadeMensal") Vencimentos mensais (desmarcado = anual, como antes)
              el-row.mb-20(type="flex", :gutter="40")
                el-col()
                  validation-provider(rules="notZero", v-slot="{ errors }")
                    app-label(label="Valor Principal:")
                    app-double-input.input(
                      key="valorPrincipal"
                      v-model='valorPrincipal',
                      prefix='R$ ',
                      :maxlength="13"
                      :hasLimitValue="true"
                      :class="{'erro' : errors.length}",
                      :propId="'label-valorPrincipal'"
                    )
                el-col(v-if="!isParcelado && isEstadoMA")
                  validation-provider(rules="max_value:100", v-slot="{ errors }")
                    app-label(label="Porcentagem de desconto (%):")
                    app-double-input.input(
                      key="porcentagemDesconto"
                      :value="porcentagemDesconto"
                      @input="setPorcentagemDesconto"
                      suffix='%'
                      :step="0.01"
                      :precision="2"
                      :class="{'erro' : errors.length}"
                    )
                    span.help.erro {{ errors[0] }}
                el-col(v-if="!isParcelado && !isEstadoRR")
                  validation-provider(rules="required", v-slot="{ errors }")
                    app-label(label="Valor do desconto:")
                    app-double-input.input(
                      v-model='valorDesconto'
                      prefix='R$ '
                      :class="{'erro' : errors.length}"
                      :disable="true"
                    )
                    span.help.erro {{ errors[0] }}
                el-col(v-if="!isParcelado")
                  app-label(label="Valor Líquido:")
                  app-double-input.input(
                    :value="valorPrincipal - valorDesconto"
                    :disable='true'
                    prefix='R$ '
                  )
                el-col()
                  app-label(label="Data de Emissão:")
                  validation-provider(rules="required", v-slot="{ errors }")
                    el-date-picker.input.full-width(
                      :picker-options='options',
                      v-model='dataEmissao',
                      format="dd/MM/yyyy",
                      disabled
                    )
                el-col(v-if="isParcelado && !isRoraima",)
                  app-label(label="Data de Vencimento:")
                  validation-provider(rules="required|dateAfterToday", v-slot="{ errors }")
                    el-date-picker.input.full-width(
                      :picker-options='options',
                      v-model='dataVencimento',
                      format="dd/MM/yyyy",
                      :disabled="isdataVencimetoHabilitada"
                    )
                    span.help.erro {{ errors[0] }}
              el-row(v-if="!isParcelado && !isEstadoMA", type="flex", :gutter="40")
                el-col(:span="6")
                  app-label(label="Data de Vencimento:")
                  validation-provider(rules="required|dateAfterToday", v-slot="{ errors }")
                    el-date-picker.input.full-width(
                      :picker-options='options',
                      v-model='dataVencimentoPreDefinida',
                      format="dd/MM/yyyy",
                      :disabled="isdataVencimetoHabilitada"
                    )
                    span.help.erro {{ errors[0] }}
              el-row(v-if="!isParcelado && isEstadoMA", type="flex", :gutter="40")
                el-col(:span="6")
                  app-label(label="Data de Vencimento:")
                  validation-provider(rules="required|dateAfterToday", v-slot="{ errors }")
                    el-date-picker.input.full-width(
                      :picker-options='options',
                      v-model='dataVencimento',
                      format="dd/MM/yyyy",
                      :disabled="isdataVencimetoHabilitada"
                    )
                    span.help.erro {{ errors[0] }}
              app-divider.mb-20(label='')
              el-row.mb-20(type="flex", :gutter="40")
                el-col()
                  app-label(label="Nome/Razão Social:")
                  el-input.input(
                    :value='dadosInteressado.nomeRazaoSocial',
                    disabled
                  )
                el-col()
                  app-label(label="CPF/CNPJ:")
                  el-input.input(
                    :value='dadosInteressado.cpfCnpj',
                    disabled
                  )
                el-col()
                  app-label(label="Número de Processo:")
                  el-input.input(
                    :value='processo.numeroProcesso',
                    disabled
                  )
              el-row.mb-20(type="flex", :gutter="40")
                el-col()
                  validation-provider(rules="required", v-slot="{ errors }")
                    app-label(label="Município:")
                    el-input.input(
                      v-model='municipio',
                      :value='utilizarMunicipio()',
                      :class="{'erro' : errors.length}"
                      maxlength="100"
                      disabled
                    )
                    span.help.erro {{ errors[0] }}
                el-col()
                  validation-provider(rules="required", v-slot="{ errors }")
                    app-label(label="Endereço:")
                    el-input.input(
                      v-model='endereco',
                      :value='utilizarEndereco()',
                      :class="{'erro' : errors.length}"
                      maxlength="100"
                      disabled
                    )
                    span.help.erro {{ errors[0] }}
                el-col()
                  validation-provider(rules="required", v-slot="{ errors }")
                    app-label(label="Telefone:")
                    el-input.input(
                      v-model='telefone',
                      :value='utilizarTelefone()',
                      :class="{'erro' : errors.length}"
                      maxlength="100"
                      disabled
                    )
                    span.help.erro {{ errors[0] }}
              el-row.mb-20(v-if="exibirTabelaParcelas && (!isEstadoMA || dataVencimento)", type="flex", :gutter="40")
                el-col(:span="8")
                  div()
                    el-table(:data="parcelasTabela",
                      class="full-width",
                    )
                      el-table-column(
                        prop="parcela",
                        label="Parcela"
                      )
                      el-table-column(
                        prop="valor",
                        label="Valor (R$)",
                      )
                      el-table-column(
                        prop="dataVencimento",
                        label="Data de vencimento"
                      )
        div(v-if="tela === 2")
          el-divider
            h3 Dados do documento
          el-row(:gutter="40")
            el-col(:span="8")
              app-display(label="Nome/Razão Social:", :content="dadosInteressado.nomeRazaoSocial")
              app-display(label="CPF/CNPJ:", :content="dadosInteressado.cpfCnpj")
              app-display(label="Endereço:", :content="endereco")
              app-display(label="Município:", :content="municipio")
            el-col(:span="8")
              app-display(label="Telefone:", :content="telefone")
              app-display(label="Nº Processo:", :content="processo.numeroProcesso")
              app-display(label="Data de Emissão:", :content="formatData(dataEmissao)")
              app-display(v-if="isEstadoMA" label="Data de Vencimento:", :content="formatData(dataVencimento)")
              app-display(v-if="!isEstadoMA" label="Data de Vencimento:", :content="formatData(dataVencimentoPreDefinida)")
            el-col(:span="8")
              app-display(label="Valor Principal:", :content="formatValor(valorPrincipal)")
              app-display(v-if="!isParcelado && !isEstadoRR", label="Valor do Desconto:", :content="formatValor(valorDesconto)")
              app-display(v-if="isParcelado && !isEdicao", label="Valor do juros:", :content="formatValor(valorTotal - valorPrincipal)")
              app-display(v-if="!isParcelado", label="Valor Total:", :content="formatValor(valorPrincipal - valorDesconto)")
              app-display(v-if="isParcelado && !isEdicao && !isRoraima", label="Valor Total:", :content="formatValor(valorTotal)")
          el-divider(v-if="exibirTabelaParcelas")
          el-row.mb-20(v-if="exibirTabelaParcelas", type="flex", :gutter="40")
            el-col(:span="8")
              div()
                el-table(:data="parcelasTabela",
                  class="full-width",
                )
                  el-table-column(
                    prop="parcela",
                    label="Parcela"
                  )
                  el-table-column(
                    prop="valor",
                    label="Valor (R$)",
                  )
                  el-table-column(
                    prop="dataVencimento",
                    label="Data de vencimento"
                  )
      div(v-else)
        div(v-if="tela === 1")
          validation-observer(ref='validation' tag='form')
            form(@submit.prevent="onSubmit" v-if="dadosInteressado")
              el-row.mb-20(type="flex", :gutter="40")
                el-col(v-if="!isParcelado")
                  validation-provider(rules="notZero", v-slot="{ errors }")
                    app-label(label="Valor Principal:")
                    app-double-input.input(
                      v-model='valorPrincipal',
                      prefix='R$ ',
                      :class="{'erro' : errors.length}"
                      :propId="'label-valorPrincipal'"
                    )
                    span.help.erro {{ errors[0] }}
                el-col()
                  app-label(label="Valor Multa:")
                  app-double-input.input(
                    :disable='true'
                    v-model='valorMulta'
                    prefix='R$ '
                  )
                el-col()
                  app-label(label="Valor Correção Monetária:")
                  app-double-input.input(
                    v-model='valorCorrecao',
                    :disable='true',
                    prefix='R$ '
                  )
                el-col()
                  app-label(label="Valor Acréscimos Monetários:")
                  app-double-input.input(
                    v-model='valorAcrescimo',
                    :disable='true',
                    prefix='R$ '
                  )
                el-col()
                  app-label(label="Valor Total:")
                  app-double-input.input(
                    :value="total()"
                    :disable='true',
                    prefix='R$ '
                  )
              el-row(type="flex", :gutter="40")
                el-col()
                  app-label(label="Data de Vencimento:")
                  validation-provider(rules="required|dateAfterToday", v-slot="{ errors }")
                    el-date-picker.input.full-width(
                      placeholder='Selecione',
                      :picker-options='options',
                      v-model='dataVencimento',
                      format="dd/MM/yyyy",
                      :class="{'erro' : errors.length}"
                      :id="'id-datavencimento'"
                    )
                    span.help.erro {{ errors[0] }}
                el-col()
                  app-label(label="Receita:")
                  el-input.input(
                    v-model='receita'
                    disabled
                  )
                el-col()
                  app-label(label="Data do Cálculo:")
                  el-input.input(
                    :value='dataCalculo',
                    prefix-icon='el-icon-date',
                    disabled
                  )
                el-col()
                  app-label(label="Referência:")
                  el-input.input(
                    :value='referencia',
                    prefix-icon='el-icon-date',
                    disabled
                  )
              app-divider.mb-20(label='')
              el-row.mb-20(type="flex", :gutter="40")
                el-col()
                  app-label(label="Nome/Razão Social:")
                  el-input.input(
                    :value='dadosInteressado.nomeRazaoSocial',
                    disabled
                  )
                el-col()
                  app-label(label="CPF/CNPJ:")
                  el-input.input(
                    :value='dadosInteressado.cpfCnpj',
                    disabled
                  )
                el-col()
                  app-label(label="Documento de Origem:")
                  el-input.input(
                    :value='processo.numeroProcesso',
                    disabled
                  )
              el-row.mb-20(type="flex", :gutter="40")
                el-col()
                  validation-provider(rules="required", v-slot="{ errors }")
                    app-label(label="Município:")
                    el-select.full-width.input(
                    v-model='idMunicipio'
                      :class="{'erro' : errors.length}"
                      @change="pegaNomeMunicipio"
                      :id="'id-municipio'"
                    )
                      el-option(
                        v-for='municipio in municipios'
                        :key='municipio.id',
                        :label='municipio.nome'
                        :value='municipio.id'
                      )
                    span.help.erro {{ errors[0] }}
                    div.mt-20(v-if="isVisualizarMunicipio")
                      a.link(@click="utilizarMunicipio()") Utilizar município do interessado
                el-col()
                  validation-provider(rules="required", v-slot="{ errors }")
                    app-label(label="Endereço:")
                    el-input.input(
                      v-model='endereco',
                      :value='endereco',
                      :class="{'erro' : errors.length}"
                      maxlength="100"
                      :id="'id-endereco'"
                    )
                    span.help.erro {{ errors[0] }}
                    div.mt-20(v-if="isVisualizarMunicipio")
                      a.link(@click='utilizarEndereco()') Utilizar endereço do interessado
                el-col()
                  validation-provider(rules="required", v-slot="{ errors }")
                    app-label(label="Telefone:")
                    el-input.input(
                      v-model='telefone',
                      :value='telefone',
                      :class="{'erro' : errors.length}"
                      :id="'id-telefone'"
                    )
                    span.help.erro {{ errors[0] }}
                    div.mt-20
                      a.link(@click="utilizarTelefone()") Utilizar telefone do interessado
              el-row
                el-col
                  app-label(
                    label="Informações Adicionais: ",
                    :required='false'
                  )
                  el-input(
                    type='textarea',
                    :rows='5',
                    placeholder='Digite o texto...',
                    v-model='informacoesAdicionais',
                    maxlength='500',
                    show-word-limit
                  )
        div(v-if="tela === 2")
          el-divider
            h3 Dados do documento
          el-row(:gutter="40")
            el-col(:span="8")
              app-display(label="Nome/Razão Social:", :content="dadosInteressado.nomeRazaoSocial")
              app-display(label="CPF/CNPJ:", :content="dadosInteressado.cpfCnpj")
              app-display(label="Endereço:", :content="endereco")
              app-display(label="Município:", :content="municipio")
              app-display(label="Telefone:", :content="telefone")
            el-col(:span="8")
              app-display(label="Documento Origem:", :content="processo.numeroProcesso")
              app-display(label="Receita:", :content="receita")
              app-display(label="Referência:", :content="receita")
              app-display(label="Data de Vencimento:", :content="formatData(dataVencimento)")
              app-display(label="Data do Cálculo:", :content="dataCalculo")
            el-col(:span="8")
              app-display(label="Valor Principal:", :content="formatValor(valorPrincipal)")
              app-display(label="Valor Multa:", :content="formatValor(valorMulta)")
              app-display(label="Valor Correção Monetária:", :content="formatValor(valorCorrecao)")
              app-display(label="Valor Acréscimos Monetários:", :content="formatValor(valorAcrescimo)")
              app-display(label="Valor Total:", :content="formatValor(valorTotal)")
              app-display(label="Informações Adicionais:", :content="informacoesAdicionais")
      app-buttons-cadastro(
        :isPrimeiroPasso='isPrimeiroPasso',
        :isUltimoPasso='tela === 2'
        @cancelar='cancelar',
        @proximo='proximo',
        @voltar='voltar',
        @finalizar='finaliza',
        :showButtonCancelar='exibirSteps',
        :showButtonProximo='exibirSteps',
        :isDae='exibirBotaoVoltarDae'
      )
    template(
      v-if="step === 2 && dadosCadastro"
    )
      el-card(shadow="hover").card-collapse
        app-despachos(
          :idProcesso="idProcesso",
          :data="dadosCadastro.setores",
          @getDownload="getDownload",
          @getAnotacao="getAnotacao"
        )
</template>

<script>
import FileSaver from 'file-saver'
import AppLabel from '@/components/AppLabel'
import AppDivider from '@/components/AppDivider'
import AppDisplay from '@/components/AppDisplay'
import AppButtonsCadastro from '@/components/AppButtonsCadastro'
import AppDoubleInput from '@/components/AppDoubleInput'
import moment from 'moment'
import { mapActions, mapState } from 'vuex'
import AppOpcoesHeaderAnalise from './components//modal/AppOpcoesHeaderAnalise'
import AppPagamento from '@/components/AppPagamento'
import AppPagamentoMa from '@/components/AppPagamentoMa'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppDespachos from '@/components/AppDespachos'
import axios from '@/utils/api'

export default {
  components: {
    AppLabel,
    AppDivider,
    AppDisplay,
    AppButtonsCadastro,
    AppDoubleInput,
    AppOpcoesHeaderAnalise,
    AppPagamento,
    AppPagamentoMa,
    AppDespachos
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      tela: 1,
      formaPagamento: null,
      passo1: true,
      ultimoPasso: false,
      valorPrincipal: 0,
      valorMulta: 0,
      valorCorrecao: 0,
      valorAcrescimo: 0,
      valorTotal: 0,
      valorDesconto: 0,
      porcentagemDesconto: 0,
      valorLiquido: 0,
      parcelaSelecionada: null,
      taxaJurosPercentual: 12,
      jurosPeriodicidadeMensal: false,
      dataEmissao: new Date(),
      dataVencimentoPreDefinida: null,
      dataVencimento: null,
      municipio: null,
      pegarMunicipio: null,
      municipios: null,
      endereco: '',
      telefone: '',
      idMunicipio: null,
      informacoesAdicionais: '',
      dadosInteressado: null,
      dadosCadastro: null,
      step: 1,
      processo: {
        numeroProcesso: null,
        numeroProtocolo: null
      },
      isEdicao: false,
      isdataVencimetoHabilitada: true,
      idBoletoEdicao: null,
      visualizarDae: false,
      isVisualizarMunicipio: false,
      vtn: null,

      options: {
        disabledDate (time) {
          return time.getTime() < Date.now()
        }
      },
      modoReparcelamento: false
    }
  },
  props: {
    idProcesso: {
      required: true
    }
  },
  async mounted () {
    this.formaPagamento = this.isEstadoMAOrRR ? 'A_VISTA' : null
    this.isdataVencimetoHabilitada = !this.isEstadoMA
    const promises = []
    promises.push(this.processoPessoa(this.idProcesso).then(resp => { this.dadosInteressado = resp }))
    promises.push(this.getProcessoById(this.idProcesso).then(resp => { this.processo = resp }))
    if (this.isEstadoMA) {
      promises.push(this.vtnByProcesso(this.idProcesso).then(resp => { this.vtn = resp }))
    }
    promises.push(this.findByCodigoEstado(process.env.ESTADO.toUpperCase()).then(resp => { this.municipios = resp || [] }))
    await Promise.all(promises)

    this.isVisualizarMunicipio = !!this.municipios.find(m => m.id === this.dadosInteressado.endereco.municipio.id)

    this.tela1()
    this.getDataVencimentoPreDefinida()
  },
  computed: {
    ...mapState({
      ORGAO: state => state.userInterface.dadosEstado.ORGAO
    }),
    isEstadoMAOrRR () {
      return process.env.ESTADO === 'ma' || process.env.ESTADO === 'rr'
    },
    isEstadoRR () {
      return process.env.ESTADO === 'rr'
    },
    isEstadoMA () {
      return process.env.ESTADO === 'ma'
    },
    isEstadoPA () {
      return process.env.ESTADO === 'pa'
    },
    exibirSteps () {
      if (this.modoReparcelamento) {
        return true
      }
      if (this.isEstadoMAOrRR && (this.processo.status !== 'AGUARDANDO_BOLETO') && !this.isEdicao) {
        return false
      } else if (this.isEstadoPA && this.processo.status === 'AGUARDANDO_PAGAMENTO' && (this.processo.tipo.codigo === 'ONEROSO' || this.processo.tipo.codigo === 'CERTIDAO_TITULO' || this.processo.tipo.codigo === 'INFORMACOES')) {
        return false
      }
      return true
    },
    exibirBotaoVoltarDae () {
      if (this.isEstadoPA && this.processo.status === 'AGUARDANDO_PAGAMENTO' && (this.processo.tipo.codigo === 'ONEROSO' || this.processo.tipo.codigo === 'CERTIDAO_TITULO' || this.processo.tipo.codigo === 'INFORMACOES')) {
        return true
      }
      return false
    },
    dataCalculo () {
      return moment(new Date()).format('DD/MM/YYYY')
    },
    referencia () {
      return moment(new Date()).format('MM/YYYY')
    },
    tituloMenuEmissao () {
      const np = this.processo && this.processo.numeroProcesso ? this.processo.numeroProcesso : ''
      const doc = this.isEstadoMA ? 'Boleto' : 'DAE'
      if (this.modoReparcelamento) {
        return `Reparcelamento — ${doc} ${np}`
      }
      return `Emissão do ${doc} ${np}`
    },
    resumoParcelasAtuais () {
      if (!this.modoReparcelamento || !this.processo.parcelas) {
        return []
      }
      const labels = {
        CRIADA: 'Criada',
        BOLETO_EMITIDO: 'Boleto emitido',
        CANCELADO: 'Cancelada'
      }
      return this.processo.parcelas
        .filter(p => p.situacaoParcela !== 'CANCELADO')
        .map((p) => {
          let rotulo = 'Parcela'
          if (p.numeroParcela === 1) {
            rotulo = 'Entrada'
          } else if (p.numeroParcela != null) {
            rotulo = `${p.numeroParcela}ª parcela`
          }
          return {
            rotulo,
            valor: Number(p.valor) || 0,
            situacaoParcela: labels[p.situacaoParcela] || (p.situacaoParcela || '-'),
            pagaLabel: p.isPaga ? 'Sim' : 'Não'
          }
        })
    },
    isPrimeiroPasso () {
      if ((this.visualizarDae && this.tela === 0) || (!this.visualizarDae && this.tela === 1)) {
        return true
      }
      return false
    },
    receita () {
      return `CUSTAS PROCESSUAIS/${this.ORGAO} 5802-5`
    },
    isParcelado () {
      return this.formaPagamento === 'PARCELADO'
    },
    parcelas () {
      return [2, 3, 4, 5]
    },
    exibirTabelaParcelas () {
      return this.isParcelado && this.parcelaSelecionada && this.valorPrincipal !== 0
    },
    parcelasTabela () {
      const taxaDecimal = this.isEstadoMA ? (Number(this.taxaJurosPercentual) || 12) / 100 : 0.12
      var linhasParcelas = [{
        parcela: 'Entrada',
        valor: this.formatValor(this.valorPrincipal * 0.2),
        dataVencimento: this.isEstadoMA ? this.formatData(this.dataVencimento) : this.formatData(new Date())
      }]
      const basePosEntrada = (this.valorPrincipal - (this.valorPrincipal * 0.2)) / (this.parcelaSelecionada - 1)
      var parcelaAtual = basePosEntrada * (1 + taxaDecimal)
      var juros = basePosEntrada * taxaDecimal
      var valorFinal = this.valorPrincipal * 0.2

      for (let index = 1; index < this.parcelaSelecionada; index++) {
        linhasParcelas = [...linhasParcelas, {
          parcela: `${index}ª Parcela`,
          valor: this.formatValor(parcelaAtual),
          dataVencimento: this.formatData(this.setDataVencimentoParcelas(index))
        }]
        valorFinal += parcelaAtual
        parcelaAtual += juros
      }

      this.setValorTotalParcelado(valorFinal)

      linhasParcelas = [...linhasParcelas, {
        parcela: 'Total',
        valor: this.formatValor(valorFinal),
        dataVencimento: ''
      }]

      return linhasParcelas
    },

    isRoraima () {
      return process.env.ESTADO === 'rr'
    },
    isReurb () {
      return this.processo.tipo.codigo === 'REURB_INDIVIDUAL'
    }
  },

  methods: {
    ...mapActions({
      getProcessoById: 'processo/getProcessoById',
      finalizar: 'analiseDae/finalisar',
      getBoletosByProcesso: 'dae/getBoletosByProcesso',
      findByCodigoEstado: 'dae/findByCodigoEstado',
      processoPessoa: 'dae/processoPessoa',
      iniciaAnalise: 'processo/iniciaAnalise',
      reemitirDae: 'dae/reemitirDae',
      updateDae: 'dae/updateDae',
      getValorBoleto: 'dae/getValorBoleto',
      vtnByProcesso: 'dae/vtnByProcesso',
      repacelarSaldoDae: 'dae/repacelarSaldoDae'
    }),
    async recarregarDadosPagamento () {
      const resp = await this.getProcessoById(this.idProcesso)
      this.processo = resp
    },
    iniciarReparcelamento () {
      this.modoReparcelamento = true
      this.isEdicao = false
      this.idBoletoEdicao = null
      this.tela = 1
      this.prefillReparcelamentoCampos()
    },
    prefillReparcelamentoCampos () {
      const pars = this.processo.parcelas || []
      const abertas = pars.filter(p => p.situacaoParcela !== 'CANCELADO' && !p.isPaga)
      const soma = abertas.reduce((s, p) => s + (Number(p.valor) || 0), 0)
      if (soma > 0) {
        this.valorPrincipal = soma
      }
      this.valorDesconto = 0
      this.porcentagemDesconto = 0
      this.formaPagamento = 'A_VISTA'
      this.parcelaSelecionada = null
      this.taxaJurosPercentual = 12
      this.jurosPeriodicidadeMensal = false
      if (!this.dataVencimento) {
        const d = new Date()
        d.setDate(d.getDate() + 1)
        this.dataVencimento = d
      }
      if (this.dadosInteressado) {
        this.utilizarMunicipio()
        this.utilizarEndereco()
        this.utilizarTelefone()
      }
    },
    montarPayloadEmitirMaOuRR () {
      const ref = moment(new Date()).format('YYYYMM')
      return {
        isParcelado: this.isParcelado,
        valorTotal: this.valorPrincipal,
        valorDesconto: this.valorDesconto,
        valorJuros: this.isParcelado ? this.valorTotal - this.valorPrincipal : 0,
        documentoOrigem: this.processo.numeroProcesso,
        enderecoSolicitante: this.endereco,
        identificacao: this.dadosInteressado.cpfCnpj,
        telefoneSolicitante: this.telefone,
        codigoReceita: '5802',
        referenciaParcela: 1,
        codigoMunicipio: this.idMunicipio,
        quantidadeParcelas: this.parcelaSelecionada,
        nomeSolicitante: this.dadosInteressado.nomeRazaoSocial,
        dataCalculo: this.dataCalculo,
        dataVencimento: this.dataVencimento ? this.dataVencimento : this.dataVencimentoPreDefinida,
        periodoReferencia: ref,
        taxaJurosPercentual: this.isEstadoMA && this.isParcelado ? this.taxaJurosPercentual : null,
        jurosPeriodicidadeMensal: this.isEstadoMA && this.isParcelado ? this.jurosPeriodicidadeMensal : false
      }
    },
    async tela1 () {
      const boletos = await this.getBoletosByProcesso(this.processo.numeroProcesso)

      if (this.isEstadoMA) {
        this.valorPrincipal = this.vtn.valorTotal
      }

      if (boletos.length > 0) {
        this.tela = 0
        this.visualizarDae = true
        return
      }

      if (this.isEstadoRR) {
        const valorBoleto = await this.getValorBoleto(this.processo.id)
        this.valorLiquido = valorBoleto
        this.valorTotal = valorBoleto
        this.valorPrincipal = valorBoleto
      }
    },
    setRadio (tipo) {
      this.formaPagamento = tipo
      this.valorDesconto = 0
      this.parcelaSelecionada = null
    },
    getDataVencimentoPreDefinida () {
      this.dataVencimentoPreDefinida = new Date()
      this.dataVencimentoPreDefinida.setDate(new Date().getDate() + 30)
    },
    setDataVencimentoParcelas (index) {
      if (!this.isEstadoMA) {
        const date = new Date()
        var dataVencimentoParcelaNaoMa = new Date()
        dataVencimentoParcelaNaoMa.setFullYear(date.getFullYear() + index)
        return dataVencimentoParcelaNaoMa
      }
      const base = new Date(this.dataVencimento)
      const dataVencimentoParcela = new Date(base.getTime())
      if (this.jurosPeriodicidadeMensal) {
        dataVencimentoParcela.setMonth(base.getMonth() + index)
      } else {
        dataVencimentoParcela.setFullYear(base.getFullYear() + index)
      }
      return dataVencimentoParcela
    },
    setValorTotalParcelado (valor) {
      this.valorTotal = valor
    },
    pegaNomeMunicipio () {
      if (this.isEstadoMAOrRR) {
        this.municipio = this.dadosInteressado.endereco.municipio.nome
        return
      }
      if (this.municipios) this.municipio = this.municipios.filter(municipio => municipio.id === this.idMunicipio)[0].nome
    },
    async handleSelect (index) {
      if (parseInt(index) === this.step) {
        return
      }
      if (this.step === 1) {
        this.step = 2
        this.dadosCadastro = await this.iniciaAnalise({idProcesso: this.idProcesso, tipoAcao: 'DAE'})
      } else {
        this.step = 1
        this.dadosCadastro = null
      }
    },
    total () {
      this.valorTotal = this.valorPrincipal + this.valorMulta + this.valorCorrecao + this.valorAcrescimo
      return this.valorTotal
    },
    async utilizarEndereco () {
      this.endereco = `${this.dadosInteressado.endereco.logradouro}, ${this.dadosInteressado.endereco.numero ? this.dadosInteressado.endereco.numero : 'sem número'}, ${this.dadosInteressado.endereco.complemento ? (this.dadosInteressado.endereco.complemento + ',') : ''} ${this.dadosInteressado.endereco.bairro}`
    },
    async utilizarTelefone () {
      this.telefone = this.dadosInteressado.telefones[0].numero
    },
    utilizarMunicipio () {
      this.idMunicipio = this.dadosInteressado.endereco.municipio.id
      this.pegaNomeMunicipio()
    },
    async checkValidacao () {
      const valido = await this.$refs.validation.validate()
      if (!valido) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Por favor, preencha os campos obrigatórios.')
        return false
      }
      return true
    },
    cancelar () {
      this.isEdicao = false
      this.$router.back()
    },
    async proximo () {
      if (this.tela === 1 && !await this.checkValidacao()) {
        return
      }
      this.tela++
      this.passo1 = false
    },
    voltar () {
      if (this.tela === 1) {
        this.isEdicao = false
        if (this.modoReparcelamento) {
          this.modoReparcelamento = false
        }
      }
      if (this.tela - 1 <= 0) this.$router.back()
      this.tela--
    },
    formatValor (valor) {
      return valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    },
    formatData (data) {
      return moment(data).format('DD/MM/YYYY')
    },

    finaliza () {
      const msgConfirm = this.modoReparcelamento
        ? 'Boletos e parcelas não quitados serão cancelados; em seguida será emitido o novo plano com os valores informados. Deseja confirmar?'
        : (this.isEstadoMA && this.isReurb ? this.$messages.CONFIRMAR_BOLETO_MA.replace('DAE', 'Boleto') : this.$messages.CONFIRMAR_BOLETO)
      this.confirmBox(msgConfirm,
        this.$messages.TITULO_WARNING,
        () => {
          const ref = moment(new Date()).format('YYYYMM')
          let boleto
          if (this.isEdicao) {
            boleto = {
              id: this.idBoletoEdicao,
              isParcelado: this.isParcelado,
              valorTotal: this.valorPrincipal,
              valorDesconto: this.valorDesconto
            }
            if (this.isEstadoMA) {
              boleto.dataVencimento = this.dataVencimento ? this.dataVencimento : this.dataVencimentoPreDefinida
              boleto.taxaJurosPercentual = this.taxaJurosPercentual
              boleto.jurosPeriodicidadeMensal = this.jurosPeriodicidadeMensal
            }
            this.updateDae(boleto).then(() => {
              this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS,
                this.isReurb ? this.$messages.BOLETO_SUCCESS_REURB_INDIVIDUAL : this.$messages.BOLETO_SUCCESS)
              this.$router.push({
                name: 'DAE'
              })
            })
          } else if (this.isEstadoMAOrRR) {
            boleto = this.montarPayloadEmitirMaOuRR()
            const eraReparcelamento = this.modoReparcelamento
            const req = this.modoReparcelamento ? this.repacelarSaldoDae(boleto) : this.finalizar(boleto)
            req.then(() => {
              this.modoReparcelamento = false
              const sucesso = eraReparcelamento
                ? 'Reparcelamento concluído com sucesso.'
                : (this.isReurb ? this.$messages.BOLETO_SUCCESS_REURB_INDIVIDUAL : this.$messages.BOLETO_SUCCESS)
              this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, sucesso)
              this.$router.push({
                name: 'DAE'
              })
            })
          } else {
            boleto = {
              codigoMunicipio: this.idMunicipio,
              dataCalculo: this.dataCalculo,
              dataVencimento: this.dataVencimento ? this.dataVencimento : this.dataVencimentoPreDefinida,
              documentoOrigem: this.processo.numeroProcesso,
              enderecoSolicitante: this.endereco,
              identificacao: this.dadosInteressado.cpfCnpj,
              informacoesAdicionais: this.informacoesAdicionais,
              isParcelado: true,
              nomeSolicitante: this.dadosInteressado.nomeRazaoSocial,
              periodoReferencia: ref,
              telefoneSolicitante: this.telefone,
              valorPrincipal: this.valorPrincipal,
              valorTotal: this.valorTotal
            }
            this.finalizar(boleto).then(() => {
              this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS,
                this.isEstadoMA ? this.$messages.BOLETO_SUCCESS.replace('DAE', 'Boleto') : this.$messages.BOLETO_SUCCESS)
              this.$router.push({
                name: 'DAE'
              })
            })
          }
        },
        () => {})
    },
    async getDownload (documento) {
      const file = await axios({
        method: 'POST',
        url: `documento/file`,
        data: documento,
        responseType: 'blob'
      })
      FileSaver.saveAs(file, documento.nome)
    },
    reemitirBoleto ({ id }) {
      this.confirmBox(this.isEstadoMA ? this.$messages.CONFIRMAR_BOLETO.replace('DAE', 'Boleto') : this.$messages.CONFIRMAR_BOLETO,
        this.$messages.TITULO_WARNING,
        () => {
          this.reemitirDae(id).then(() => {
            this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS,
              this.isReurb ? this.$messages.BOLETO_SUCCESS_REURB_INDIVIDUAL : this.$messages.BOLETO_SUCCESS)
            this.$router.push({
              name: 'DAE'
            })
          })
        },
        () => {})
    },
    editarDae (boleto) {
      this.idBoletoEdicao = boleto.id
      this.isEdicao = true
      this.valorPrincipal = boleto.valorPrincipal
      this.formaPagamento = boleto.isParcelado ? 'PARCELADO' : 'A_VISTA'
      this.valorDesconto = (boleto.desconto && !this.isEstadoMA) ? boleto.desconto : 0
      if (this.isEstadoMA && boleto.isParcelado) {
        this.taxaJurosPercentual = boleto.taxaJurosPercentual != null ? Number(boleto.taxaJurosPercentual) : 12
        this.jurosPeriodicidadeMensal = !!boleto.jurosPeriodicidadeMensal
      }
      this.proximo()
    },
    setPorcentagemDesconto (value) {
      this.porcentagemDesconto = value
      this.valorDesconto = ((this.valorPrincipal * value) / 100)
    }
  }
}
</script>

<style scoped lang="scss">
.medium-margin-top {
  margin-top: 20px;
}

.small-margin-top {
  margin-top: 10px;
}

.flex {
  display: flex;
}

.margin-btn {
  width: 16px;
  height: 25px;
  margin-bottom: 20px;
}

.justify {
  justify-content: space-between;
}

.btn {
  padding: 8px;
  margin-top: 1vh;
}

.disabled {
  background-color: #f5f7fa;
  color: #c8c5d3;
  cursor: not-allowed;
}

.full-width {
  width: -webkit-fill-available;
}

.mt-20 {
  margin-top: 20px;
}

.mb-20 {
  margin-bottom: 20px;
}

.mb-40 {
  margin-bottom: 40px;
}
.el-input__prefix {
  margin-top: 12px;
}

.link {
  cursor: pointer;
  color: #009f61;
  &:hover {
    font-weight: bold;
  }
}

.card-container {
  margin: 20px;
  border-radius: 10px;
}

.titulo-analise {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  border-bottom: solid 1px #e6e6e6;
}

>>> .el-table__row {
  &:last-child {
    font-weight: bold;
  }
}

.select-erro {
  border: 1px solid #b22222;
  border-radius: 4px;
  border-color: #b22222;
  -webkit-box-shadow: inset 0 1px 2px #ff867c, 0 0 9px #b22222;
  box-shadow: inset 0 1px 2px #ff867c, 0 0 4px #ff867c;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/EmitirDae.vue